import React from 'react';
import SlideLayout, { SlideTitle, SlideContent } from '../components/SlideLayout';
import { Zap, Clock, Eye, CheckCircle } from 'lucide-react';

const WhatIsReasoningSlide = () => {
  return (
    <SlideLayout maxWidth="6xl">
      <SlideTitle 
        subtitle="Systematic problem decomposition with verifiable logic"
      >
        What is "Reasoning" in LLMs?
      </SlideTitle>
      
      <SlideContent>
        {/* Definition */}
        <div className="slide-card mb-8 border-primary/30">
          <p className="text-lg text-foreground">
            <strong className="text-primary">Definition:</strong> The ability to decompose complex problems into steps, 
            maintain consistent logic chains, and arrive at verifiable solutions.
          </p>
        </div>
        
        {/* Comparison table */}
        <div className="slide-card overflow-hidden mb-8">
          <table className="comparison-table">
            <thead>
              <tr>
                <th>Standard Generation</th>
                <th>Reasoning Behavior</th>
              </tr>
            </thead>
            <tbody>
              {[
                ['Direct answer from patterns', 'Explicit step-by-step breakdown'],
                ['Single forward pass', 'Chain-of-thought processing'],
                ['Memorized knowledge', 'Derived conclusions'],
                ['Fast, cheap', 'Slower, more compute-intensive'],
              ].map((row, index) => (
                <tr key={index}>
                  <td className="text-muted-foreground">{row[0]}</td>
                  <td className="text-primary">{row[1]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        
        {/* Key insight */}
        <div className="grid md:grid-cols-4 gap-4">
          {[
            { icon: Eye, label: 'Transparency', desc: 'Audit the reasoning process' },
            { icon: CheckCircle, label: 'Accuracy', desc: 'Catches errors in steps' },
            { icon: Zap, label: 'Generalization', desc: 'Works on novel problems' },
            { icon: Clock, label: 'Trade-off', desc: 'More compute for better answers' },
          ].map((item, index) => {
            const Icon = item.icon;
            return (
              <div key={index} className="slide-card text-center">
                <Icon className="w-6 h-6 text-primary mx-auto mb-2" />
                <div className="font-heading font-semibold text-foreground text-sm">{item.label}</div>
                <div className="text-xs text-muted-foreground mt-1">{item.desc}</div>
              </div>
            );
          })}
        </div>
      </SlideContent>
    </SlideLayout>
  );
};

export default WhatIsReasoningSlide;
